import { render, staticRenderFns } from "./EditDocumentDialog.vue?vue&type=template&id=32b3e4d6"
import script from "./EditDocumentDialog.vue?vue&type=script&lang=js"
export * from "./EditDocumentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports